(function () {
    'use strict';

    angular
        .module('website', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ui.router', 'ui.bootstrap', 'toastr']);

})();

(function() {
    'use strict';

    angular
        .module('website')
        .directive('malarkey', malarkey);

    /** @ngInject */
    function malarkey (malarkey) {
        return {
            restrict: 'E',
            scope: {
                extraValues: '='
            },
            link: linkFunc,
            controller: MalarkeyController,
            controllerAs: 'vm'
        };

        function linkFunc (scope, el, attrs, vm) {
            var watcher;
            var typist = malarkey(el[0], {
                typeSpeed: 50,
                deleteSpeed: 70,
                pauseDelay: 1000,
                loop: true,
                postfix: ' '
            });

            el.addClass('malarkey');

            scope.extraValues = [].concat(['=============']);
            angular.forEach(scope.extraValues, function(value) {
                typist.type(value).pause().delete();
            });

            watcher = scope.$watch('vm.roles', function () {
                angular.forEach(vm.roles, function (role) {
                    typist.type(role).pause().delete();
                });
            });

            scope.$on('$destroy', function () {
                watcher();
            });
        }

        /** @ngInject */
        function MalarkeyController(aboutService) {
            var vm = this;

            vm.roles = [];

            activate();

            function activate () {
                aboutService.getRoles().then(function (roles) {
                    vm.roles = roles
                });
            }
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('website')
        .service('aboutService', aboutService);

    /** @ngInject */
    function aboutService ($q) {

        var infos = {
            name: 'Michael P. Bazos',
            location: 'The Internet',
            links: [
                {title: 'Stack Overflow', icon: 'stack-overflow', href: 'http://stackoverflow.com/users/3120193/michael-p-bazos'},
                {title: 'LinkedIn', icon: 'linkedin', href: 'https://www.linkedin.com/in/michaelbazos'},
                {title: 'Twitter', icon: 'twitter', href: 'https://twitter.com/michaelbazos'},
                {title: 'Github', icon: 'github', href: 'https://github.com/michaelbazos'}
            ],
            roles: ['Contributor', 'Developer', 'Traveler', 'Jogger', 'Sleeper']
        };

        /**
         * Returns about information
         */
        this.getInfos = function () {
            return $q.when(infos);
        };

        /**
         * Returns roles
         */
        this.getRoles = function () {
            return $q.when(infos.roles);
        };

        return this;
    }

})();

(function () {
    'use strict';

    angular
        .module('website')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController ($window, aboutService) {
        var vm = this;

        aboutService.getInfos().then(function (data) {
            vm.infos = data;
        });

        vm.open = function (link) {
            $window.open(link, '_self');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('website')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state) {

        $rootScope.$state = $state;

    }

})();

(function () {
    'use strict';

    angular
        .module('website')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('home', {
                url: '/',
                templateUrl: 'app/home/home.html',
                controller: 'HomeController',
                controllerAs: 'home'
            });

        $urlRouterProvider.otherwise('/');
    }

})();

/* global malarkey:false, moment:false */
(function () {
    'use strict';

    angular
        .module('website')
        .constant('malarkey', malarkey)
        .constant('moment', moment);

})();

(function () {
    'use strict';

    angular
        .module('website')
        .config(config);

    /** @ngInject */
    function config($logProvider, toastrConfig) {
        // Enable log
        $logProvider.debugEnabled(true);

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = true;
        toastrConfig.progressBar = true;
    }

})();

angular.module("website").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/home.html","<div class=\"container flex-container\"><section class=\"about-me center-block\"><div class=\"about-me__name\">{{home.infos.name}}</div><div class=\"about-me__roles\">#<malarkey></malarkey></div><div class=\"about-me__location\"><i class=\"fa fa-street-view\"></i> <b>{{home.infos.location}}</b></div><ul class=\"list-inline about-me__links\"><li ng-repeat=\"link in home.infos.links\" ng-click=\"home.open(link.href)\"><i class=\"fa fa-{{link.icon}}\"></i></li></ul></section></div>");}]);